import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Container, Grid, Typography } from '@material-ui/core';

import { useWkblScript } from 'hooks';
import { RootState } from 'redux/reducers/type';

import { ViewMode } from 'commons/constants/KeyFlowConstants';
import { ViewModeType } from 'commons/constants/type';

import { Pagination } from 'components/Pagination';
import { SquareSwitch } from 'components/Switch';
import { useStyles } from 'components/SearchResult';
import { WkblScriptListView } from 'components/ScriptListView';
import { WkblScriptThumbnailView } from 'components/ScriptThumbnailView';
import { OrderSelect, PageReturnSelect } from 'components/Select';
import { addComma } from '../../commons/utils/commonUtil';

function SearchResultByRecord() {
  const classes = useStyles();
  const {
    onChangeWkblScriptPage,
    onChangeWkblScriptSort,
    onChangeWkblScriptAsc,
    onChangeWkblScriptReturnCount,
    onClearWkblScriptList,
  } = useWkblScript();

  const {
    wkblScriptList: scriptList,
    pagination,
    searchCondition,
  } = useSelector((state: RootState) => state.wkblScript);

  const [viewMode, setViewMode] = useState<ViewModeType>(ViewMode.THUMBNAIL);

  const isEmptyData = useMemo(() => {
    return scriptList.length === 0;
  }, [scriptList.length]);

  useEffect(() => {
    return () => {
      onClearWkblScriptList();
    };
  }, [onClearWkblScriptList]);

  const onChangePage = useCallback(
    (pageNumber: number) => {
      onChangeWkblScriptPage(pageNumber);
    },
    [onChangeWkblScriptPage],
  );

  const onChangeViewMode = useCallback(() => {
    if (viewMode === ViewMode.LIST) {
      setViewMode(ViewMode.THUMBNAIL);
    } else {
      setViewMode(ViewMode.LIST);
    }
  }, [viewMode]);

  return (
    <Container component="article" className={classes.root}>
      <div className={classes.optionContainer}>
        <p className={classes.resultCount}>검색 결과 : {addComma(pagination.itemCount)}개</p>

        <div className={classes.searchOptionContainer}>
          <SquareSwitch onChange={onChangeViewMode} value={viewMode} />
          <OrderSelect
            asc={searchCondition.asc}
            sort={searchCondition.sort}
            onChangeAsc={onChangeWkblScriptAsc}
            onChangeSort={onChangeWkblScriptSort}
          />
          <PageReturnSelect
            returnCount={pagination.returnCount || searchCondition.retr}
            onChangeReturnCount={onChangeWkblScriptReturnCount}
          />
        </div>
      </div>
      {isEmptyData ? (
        <Grid container justifyContent="center" className={classes.emptyDataContainer}>
          <Grid item xs={4}>
            <Typography>데이터가 존재하지 않습니다.</Typography>
          </Grid>
        </Grid>
      ) : viewMode ? (
        <WkblScriptListView />
      ) : (
        <WkblScriptThumbnailView />
      )}
      <Grid container justifyContent="center">
        <Grid item xs={9} className={classes.paginationContainer}>
          <Pagination pagination={pagination} onChangePage={onChangePage} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default SearchResultByRecord;
